<template>
  <div class="signin-bg">
    <img class="logo" src="../assets/comm/logo.png" alt="logo">

    <div class="register-from">
      <div class="tab">
        <a :class="{'active':registerForm}" @click="registerForm=true">密码登录</a>
        <a :class="{'active':!registerForm}" @click="registerForm=false">短信登录</a>
        <p class="line"></p>
      </div>
      <form action="#" ref="passForm" :model="passForm" v-if="registerForm">
      <div class="inputbox">
        <input type="text"
               name="email"
               autocomplete="off"
               v-model="passForm.user_name"
               placeholder="手机号/账号"
        />
        <input
                type="password"
                name="password"
                autocomplete="off"
                v-model="passForm.password"
                placeholder="密码"
        />
      </div>
      <p class="btn_but">
        <button class="signbtn" @click.prevent="passSignUp">登录</button>
      </p>
      <p class="already-sign">
        <a href="javascript:;" style="float: left"><span>
            <input
                    type="checkbox"
                    name="agree"
                    v-model="passForm.isAgree"
                    class="agree"
                    id="agree"
            >
            <label for="agree"></label>
          </span>
        <span class="agree-txt">下次自动登录</span>
        </a>
          <router-link :to="{name:'Forgot'}">忘记密码</router-link>
         <!-- <router-link :to="{name:'Register'}" style="margin-right: 20px">注册</router-link>-->
        
      </p>
    </form>
      <form action="#" ref="smsForm" :model="smsForm" v-if="!registerForm">
        <div class="inputbox">
          <input type="text"
                 name="email"
                 autocomplete="off"
                 v-model="smsForm.user_name"
                 placeholder="手机号/账号"
          />
          <div class="slide">
            <drag-verify ref="dragVerify" :width="width" :height="height" :text="text" :success-text="successText" :background="background" color="blue" :progress-bar-bg="progressBarBg" :completed-bg="completedBg" :handler-bg="handlerBg" :handler-icon="handlerIcon" :text-size="textSize" :success-icon="successIcon" :circle="isCircle"></drag-verify>
          </div>

          <div>
            <input
                    class="verifcode"
                    type="text"
                    name="code"
                    autocomplete="off"
                    v-model="smsForm.code"
                    placeholder="验证码"
            />
            <button class="getverifcode" @click.prevent="getCode" :disabled="codeDisabled">{{codeMsg}}</button>
          </div>
        </div>
        <p class="btn_but">
          <button class="signbtn" @click.prevent="smsSignUp">登录</button>
        </p>
        <p class="already-sign">
          <a href="javascript:;" style="float: left"><span>
            <input
                    type="checkbox"
                    name="agree"
                    v-model="smsForm.isAgree"
                    class="agree"
            >
            <label for="agree"></label>
          </span>
            
            <span class="agree-txt">下次自动登录</span>
          </a>
           <!-- <router-link :to="{name:'Register'}">注册</router-link>-->
          <router-link :to="{name:'Forgot'}">忘记密码</router-link>
          
        </p>
      </form>
    </div>
    <p class="copyright">ALL  RIGHTS  RESERVED.广州影美晴信息科技有限责任公司  粤B2-20150265 | 粤网文  （2018）8475-3059号 | <a href="http://beian.miit.gov.cn" target="_blank" style="color: #999999;">粤ICP备14050742号-3</a> | 粤公网备 44010502001214号</p>
  </div>
</template>

<script>
  import dragVerify from '@/components/dragVerify'
  export default {
    name: 'Register',
    components:{
      dragVerify
    },
    data() {
      return {
        registerForm:true,
        passForm: {
          user_name:'',
          password:'',
          isAgree:''
        },
        smsForm:{
          user_name:'',
          code:'',
          isAgree:''
        },
        codeMsg:'获取验证码',
        codeDisabled:false,
        handlerIcon: "fa fa-angle-double-right",
        successIcon: "fa fa-check",
        background: "#f7f7f7",
        color :"#999999",
        progressBarBg: "#4b0",
        completedBg: "#66cc66",
        handlerBg: "#fff",
        text: "请按住滑块、拖动到最右边",
        successText: "验证成功",
        width: 360,
        height: 48,
        textSize: "14px",
        isCircle:true,
          user_id:'',
      }
    },

    mounted() {
      this.checkSignUp()
    },
    methods: {
      checkSignUp(){
        if(this.getCookie('token')){
          this.$router.push({name:'Index'})
        }
      },
      getCode(){
        //获取验证码
        if(!this.smsForm.user_name){
          this.$message({
            message: '请填写手机号/账号',
            type: 'error'
          });
          return
        }
        if(!this.$refs.dragVerify.isPassing){
          this.$message({
            message: '请完成滑块校验',
            type: 'error'
          });
          return
        }

        this.$post('/sendCode',{user_name:this.smsForm.user_name})
                .then( res => {
                  if(res.code == 200){
                    this.$message({
                      showClose: true,
                      message: res.data,
                      type: 'success'
                    });
                    this.codeDisabled = true
                    this.count = 60;
                    this.timer = setInterval(()=>{
                      if(this.count > 0 && this.count <= 60){
                        this.count--;
                        this.codeMsg = this.count
                      }else{
                        clearInterval(this.timer);
                        this.timer = null;
                        this.codeDisabled = false
                        this.codeMsg = '获取验证码'
                        this.$refs.dragVerify.reset()
                      }
                    },1000)
                  }else{
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: 'error'
                    });
                  }
                })
                .catch(error => {
                  console.log(error)
                })
      },
      passSignUp(){
        //密码登录
        this.$post('/login',this.passForm)
                .then( res => {
                  if(res.code == 200){
                    let days = 0.5
                    if(this.passForm.isAgree){
                      days = res.data.expires_in/(86400)
                    }
                    this.setCookie('token',res.data.access_token,days)
                    const history = this.getCookie('history')
                    if (history) {
                      this.$router.push(history)
                    } else {
                      this.$router.push({name:'Index'})
                    }
                  }else{
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: 'error'
                    });
                  }
                    this.$get('/me').then(res=>{
                        if(res.code == 200){
                            this.user_id = res.data.user.id
                            console.log(res.data.user.id);
                            this.$post('/es/login',{user_id:this.user_id})
                                .then( res => {
                                }).catch(errors => {
                                console.log(errors);
                            })
                        }
                    })
                })
                .catch(error => {
                  console.log(error.message)
                })
      },
      smsSignUp(){
        //短信登录
        this.$post('/loginWithCode',this.smsForm)
                .then( res => {
                  if(res.code == 200){
                    let days = res.data.expires_in/(86400)
                    if(this.smsForm.isAgree){
                      days = 0.5
                    }
                    this.setCookie('token',res.data.access_token,days)
                    this.$router.push({name:'Index'})
                  }else{
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: 'error'
                    });
                  }
                    this.$get('/me').then(res=>{
                        if(res.code == 200){
                            this.user_id = res.data.user.id
                            this.$post('/es/login',{user_id:this.user_id})
                                .then( res => {
                                }).catch(errors => {
                                console.log(errors);
                            })
                        }
                    })
                })
                .catch(error => {
                  console.log(error.message)
                })
      },
    }
  }
</script>

<style scoped>
  .signin-bg{
    height: 1030px;
    background: url("../assets/signin/bg.png");
  }
  .signin-bg .logo{
    margin: 146px auto 47px;
  }
  .register-from {
    width: 487px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 20px;
    padding: 70px 65px 155px;
  }
  .register-from .tab a.active{
    color: #2a2a2a;
  }
  .register-from .tab a.active:before{
    display: block;
    content: '';
    position: absolute;
    left: 35%;
    bottom: -18px;
    width: 50px;
    height: 4px;
    background-color: #ff9f00;

  }
  .register-from .tab a{
    font-family: MicrosoftYaHei;
    position: relative;
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 18px;
    color: #999999;
    cursor: pointer;
  }
  .register-from .line{
    width: 361px;
    height: 1px;
    background-color: #f7f7f7;

  }
  .register-from input {
    outline: none;
    padding-left: 15px;
    -webkit-appearance: none;
  }
  .register-from .inputbox{
    margin: 38px auto 20px;
  }
  input{
    width: 361px;
    height: 48px;
    background-color: #f7f7f7;
    border-radius: 24px;
    border: none;
    font-size: 15px;
    margin: 11px 0;
  }
  .verifcode{
    width: 196px;
  }
  .getverifcode{
    width: 150px;
    height: 48px;
    background-color: #ffeccc;
    border-radius: 24px;
    font-size: 14px;
    color: #ff9f00;
    border: none;
    cursor: pointer;
    margin-left: 11px;
  }
  .visibility{
    display: none;
    /*overflow: hidden;*/
  }

  .agree-txt{
    font-size: 14px;
    color: #999999;
    text-align: left;
  }

  .agree {
    position: absolute;
    width: 20px;
    height: 20px;
    visibility: hidden;
  }
  .agree + label {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../assets/signin/combobox_unselect.png") no-repeat;
    vertical-align: middle;
  }
  .agree:checked + label {
    background: url("../assets/signin/combobox_select.png") no-repeat;
  }
  .signbtn {
    width: 361px;
    height: 48px;
    background-color: #ff9f00;
    border-radius: 24px;
    border: none;
    font-size: 16px;
    cursor: pointer;
    line-height: 28px;
    color: #ffffff;
  }
  .already-sign {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #666666;
  }
  .already-sign a {
    font-size: 14px;
    color: #999999;
    float: right;
  }
  .copyright{
    margin-top: 140px;
    font-size: 12px;
    color: #999999;
  }
  input::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
  }
  input::-moz-placeholder {
    color: #999999;
    font-size: 16px;
  }
  input:-moz-placeholder {
    color: #999999;
    font-size: 16px;
  }
  input:-ms-input-placeholder {
    color: #999999;
    font-size: 16px;
  }
  .relat {
    position: relative;
  }
  .signbut:hover {
    background: #0293bf;
    text-decoration: none;
    color: #fff;
  }
  .btn_but {
    margin-top: 30px;
  }
  .signbut.disable{cursor: not-allowed;-webkit-box-shadow: none;box-shadow: none;opacity: .6;background-color: #00bde3;}
  .signbut.disable:hover{background-color: #00bde3;}

  .slide{
    position: relative;
    background-color: #f7f7f7;
    border-radius: 24px;
    height: 48px;
    line-height: 48px;
    margin: 11px 0;
  }
  .slide span{
    position: absolute;
    left: 0;
    display: inline-block;
    width: 48px;
    height: 48px;
    background-color: #ffffff;
    box-shadow: 0px 4px 6px 0px
    rgba(51, 51, 51, 0.1);
    border: solid 1px #e8e8e8;
    border-radius: 100%;
  }
  .slide p{
    font-size:14px;
    color: #999999;
  }
</style>

